





import Vue from "vue";
import { mapState } from "vuex";

export default Vue.extend({
  data() {
    return {
      loading: true,
    };
  },
  beforeRouteEnter(to, from, next) {
    if (Object.keys(to.query).length !== 0) {
      next((vm) => {
        (vm as any).join(vm, to.query.id, to.query.token);
      });
    }
  },
  destroyed() {},
  updated() {},
  watch: {},
  methods: {
    join(vm, id, token) {
      vm.$store
        .dispatch("app/authenticateViaReviewInvitation", {
          invitationId: id,
          token: token,
        })
        .then((response) => {
          location.replace(window.location.origin + abp.appPath);
        })
        .finally(() => {
          vm.loading = false;
        });
    },
  },
});
